import { render } from "./ProjectComponent.vue?vue&type=template&id=bb697f34&scoped=true"
import script from "./ProjectComponent.vue?vue&type=script&lang=js"
export * from "./ProjectComponent.vue?vue&type=script&lang=js"

import "./ProjectComponent.vue?vue&type=style&index=0&id=bb697f34&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bb697f34"]])

export default __exports__